import { useState } from 'react';

const useToggleProfileCard = (initialValue = false) => {
  const [isShowProfileCard, setIsShowProfileCard] = useState(initialValue);

  return [isShowProfileCard, setIsShowProfileCard] as const;
};

export default useToggleProfileCard;
